var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-6 mt-8" }, [
    _c("div", { staticClass: "flex flex-col sm:rounded-lg bg-white" }, [
      _c("div", { staticClass: "flex-grow overflow-auto overflow-x-visible" }, [
        _c(
          "table",
          {
            staticClass:
              "relative w-full text-sm font-normal text-left dark:text-gray-400",
          },
          [
            _vm._m(0),
            _c(
              "tbody",
              { staticClass: "divide-y" },
              _vm._l(_vm.suitableContractors, function (resource) {
                return _c(
                  "tr",
                  {
                    key: resource.id,
                    staticClass:
                      "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                  },
                  [
                    _c("td", { staticClass: "px-1.5 py-2" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-storm-gray text-sm p-1.5 font-medium rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                        },
                        [
                          resource.name
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex flex-row items-center",
                                  attrs: {
                                    name: "imageAvatar",
                                    image: resource.avatar,
                                  },
                                },
                                [
                                  resource.avatar !== null
                                    ? _c("S3Image", {
                                        class: [
                                          _vm.defaultImageClasses,
                                          _vm.avatarStyleClasses,
                                        ],
                                        attrs: { s3FileKey: resource.avatar },
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs leading-none font-semibold mr-1",
                                          class: _vm.getAvatrClass,
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getInitials(resource.name)
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-storm-gray text-sm font-medium",
                                    },
                                    [_vm._v(" " + _vm._s(resource.name) + " ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _c("td", { staticClass: "px-1.5 py-2" }, [
                      _vm._v(_vm._s(_vm.contarctorJob(resource))),
                    ]),
                    _c("td", { staticClass: "px-1.5 py-2" }, [
                      _vm._v(_vm._s(_vm.contractorRates(resource))),
                    ]),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-1.5 items-center" },
                        [
                          _c(
                            "RouterLink",
                            {
                              attrs: { to: _vm.contractorPageRoute(resource) },
                            },
                            [
                              _c(
                                "button",
                                { staticClass: "flex flex-row items-center" },
                                [_c("TableViewIcon")],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleCopy(resource)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  staticClass:
                                    "flex items-center ml-1 b-tooltipZ",
                                  attrs: {
                                    variant: _vm.TooltipVariants.DARK,
                                    title: "Copy Link",
                                    tooltipClasses: "fitWidth",
                                    placement: "top",
                                    arraowClass: "hideArrow",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-1 hoverBack" },
                                    [_c("CopyLink")],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "thead",
      {
        staticClass: "text-m text-black headingTable sticky top-0 z-100 w-full",
      },
      [
        _c("tr", [
          _c(
            "th",
            {
              staticClass: "px-1.5 py-2 text-sm relative font-medium leading-6",
              staticStyle: { width: "45%" },
              attrs: { scope: "col" },
            },
            [
              _vm._v(" Resource "),
              _c("span", { staticClass: "right-border px-4 absolute right-4" }),
            ]
          ),
          _c(
            "th",
            {
              staticClass: "px-1.5 py-2 text-sm relative font-medium leading-6",
              staticStyle: { width: "25%" },
              attrs: { scope: "col" },
            },
            [
              _vm._v(" Classification "),
              _c("span", { staticClass: "right-border px-4 absolute right-4" }),
            ]
          ),
          _c(
            "th",
            {
              staticClass: "px-1.5 py-2 text-sm relative font-medium leading-6",
              staticStyle: { width: "25%" },
              attrs: { scope: "col" },
            },
            [
              _vm._v(" Rate "),
              _c("span", { staticClass: "right-border px-4 absolute right-4" }),
            ]
          ),
          _c("th", {
            staticClass: "px-1.5 py-2 text-sm relative",
            staticStyle: { width: "5%" },
            attrs: { scope: "col" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }